module.exports = __webpack_public_path__ + "static/shoutcart_img1-b14a9fe1ce62b514e60d678cb043c77b.png";